<template>
  <div>
    <v-row>
      <v-col class="">
        <v-card
          v-if="!!selectedMailConfig.genericMailTemplate"
          class="rounded"
          :style="{ backgroundColor: `rgb(var(--v-theme-custom-success-lighten))` }"
        >
          <v-card-text
            class="text-success text-darken-1 d-flex justify-space-between align-center"
          >
            <div>
              <v-icon start> mdi-check </v-icon>
              Es ist eine E-Mail-Vorlage hinterlegt.
            </div>

            <v-btn
              size="small"
              variant="outlined"
              @click="showEditTemplateDialog = true"
              >Bearbeiten</v-btn
            >
          </v-card-text>
        </v-card>
        <v-card
          v-else
          class="rounded"
          :style="{ backgroundColor: `rgb(var(--v-theme-custom-error-lighten))` }"
        >
          <v-card-text
            class="text-error-darken-1 d-flex justify-space-between align-center"
            :style="{ color: `rgb(var(--v-theme-custom-error-darker))` }"
          >
            <div>
              <v-icon start> mdi-check </v-icon>
              Es ist keine E-Mail-Vorlage hinterlegt.
            </div>

            <v-btn
              size="small"
              variant="outlined"
              @click="showEditTemplateDialog = true"
              >bearbeiten</v-btn
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          bg-color="accent"
          variant="filled"
          label="E-Mail-Adresse"
          :rules="showValidation ? validationRules.mail : []"
          v-model="selectedMailConfig.noreplyMail"
          @update:model-value="changeData"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          bg-color="accent"
          variant="filled"
          label="Anzeigename"
          v-model="selectedMailConfig.noreplyDisplayName"
          @update:model-value="changeData"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h4 class="mb-2">E-Mail-Versandmethoden</h4>
      </v-col>
    </v-row>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-title
          color="accent"
          expand-icon="mdi-menu-down"
          class="panel-header"
        >
          <template v-slot:default="{ expanded }">
            <v-row no-gutters align="center">
              <v-col cols="4">
                <span class="text-subtitle-1"> SMTP </span>
              </v-col>
              <v-col cols="2">
                <v-fade-transition leave-absolute>
                  <div v-if="!expanded">
                    <v-icon
                      v-if="!selectedMailConfig.noreplyUseGraphApi"
                      color="success"
                      >mdi-check</v-icon
                    >
                    <span
                      v-if="!selectedMailConfig.noreplyUseGraphApi"
                      class="ml-2"
                      >Aktiv</span
                    >

                    <v-icon
                      v-if="selectedMailConfig.noreplyUseGraphApi"
                      color="error"
                      >mdi-close</v-icon
                    >
                    <span
                      v-if="selectedMailConfig.noreplyUseGraphApi"
                      class="ml-2"
                      >Inaktiv</span
                    >
                  </div>
                </v-fade-transition>
              </v-col>
            </v-row>
          </template>
        </v-expansion-panel-title>
        <v-expansion-panel-text density="compact">
          <v-row class="mb-0">
            <v-col cols="12">
              <v-switch
                v-model="selectedMailConfig.noreplyUseGraphApi"
                color="primary"
                hide-details
                :true-value="false"
                :false-value="true"
                label="SMTP als E-Mail-Versandmethode aktivieren"
                class="mt-2"
                @update:model-value="changeData"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col>
              <v-text-field
                bg-color="accent"
                variant="filled"
                label="SMTP-Server"
                v-model="selectedMailConfig.noreplyHost"
                @update:model-value="changeData"
              ></v-text-field>
            </v-col>
            <v-col md="2">
              <v-text-field
                bg-color="accent"
                variant="filled"
                label="Port"
                v-model="selectedMailConfig.noreplyPort"
                @update:model-value="changeData"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="">
              <v-text-field
                bg-color="accent"
                variant="filled"
                hide-details
                label="Benutzername"
                v-model="selectedMailConfig.noreplyUser"
                @update:model-value="changeData"
              ></v-text-field>
            </v-col>
            <v-col class="">
              <v-text-field
                bg-color="accent"
                variant="filled"
                hide-details
                label="Passwort"
                v-model="selectedMailConfig.noreplyPassword"
                @update:model-value="changeData"
                :append-inner-icon="
                  showNoreplyPassword ? 'mdi-eye' : 'mdi-eye-off'
                "
                @click:append-inner="showNoreplyPassword = !showNoreplyPassword"
                :type="showNoreplyPassword ? 'text' : 'password'"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-switch
                v-model="selectedMailConfig.noreplyStarttls"
                @update:model-value="changeData"
                color="primary"
                label="StartTLS aktivieren"
                hide-details
              ></v-switch>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title
          color="accent"
          expand-icon="mdi-menu-down"
          class="panel-header"
        >
          <template v-slot:default="{ expanded }">
            <v-row no-gutters align="center">
              <v-col cols="4">
                <span class="text-subtitle-1"> Graph Api (Office365) </span>
              </v-col>
              <v-col  cols="2">
                <v-fade-transition leave-absolute>
                  <div v-if="!expanded">
                    <v-icon
                      v-if="selectedMailConfig.noreplyUseGraphApi"
                      color="success"
                      >mdi-check</v-icon
                    >
                    <span
                      v-if="selectedMailConfig.noreplyUseGraphApi"
                      class="ml-2"
                      >Aktiv</span
                    >

                    <v-icon
                      v-if="!selectedMailConfig.noreplyUseGraphApi"
                      color="error"
                      >mdi-close</v-icon
                    >
                    <span
                      v-if="!selectedMailConfig.noreplyUseGraphApi"
                      class="ml-2"
                      >Inaktiv</span
                    >
                  </div>
                </v-fade-transition>
              </v-col>
            </v-row>
          </template>
        </v-expansion-panel-title>
        <v-expansion-panel-text class="mt-3">
          <v-row>
            <v-col cols="12">
              <v-switch
                v-model="selectedMailConfig.noreplyUseGraphApi"
                color="primary"
                hide-details
                label="Graph Api als E-Mail-Versandmethode aktivieren"
                class="mt-2"
                @update:model-value="changeData"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="">
              <v-text-field
                bg-color="accent"
                variant="filled"
                label="Tenant ID"
                v-model="selectedMailConfig.noreplyGraphTenantId"
                @update:model-value="changeData"
              ></v-text-field>
            </v-col>
            <v-col class="">
              <v-text-field
                bg-color="accent"
                variant="filled"
                label="Client ID"
                v-model="selectedMailConfig.noreplyGraphClientId"
                @update:model-value="changeData"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="">
              <v-text-field
                bg-color="accent"
                variant="filled"
                label="Client Secret"
                v-model="selectedMailConfig.noreplyGraphClientSecret"
                @update:model-value="changeData"
                :append-inner-icon="
                  showClientSecret ? 'mdi-eye' : 'mdi-eye-off'
                "
                @click:append-inner="showClientSecret = !showClientSecret"
                :type="showClientSecret ? 'text' : 'password'"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
    <MailTemplateDialog
      :open="showEditTemplateDialog"
      :mail-template="selectedMailConfig.genericMailTemplate"
      @submit="onSubmitTemplate"
      @close="showEditTemplateDialog = false"
    ></MailTemplateDialog>
  </div>
</template>

<script>
import MailTemplateDialog from "@/components/Tenant/MailTemplateDialog.vue";

export default {
  name: "MailKonfiguration",
  components: { MailTemplateDialog },
  props: {
    mailConfig: {
      type: Object,
      required: true,
    },
    showValidation: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showNoreplyPassword: false,
      showClientSecret: false,
      showEditTemplateDialog: false,
      validationRules: {
        mail: [
          (v) => !!v || "Pflichtfeld",
          (v) => /.+@.+\..+/.test(v) || "Muss gültige Email-Adresse sein.",
        ],
      },
    };
  },
  computed: {
    selectedMailConfig: {
      get() {
        return this.mailConfig;
      },
    },
  },
  methods: {
    changeData() {
      this.$emit("update", this.selectedMailConfig);
    },
    onSubmitTemplate(newTempalte) {
      this.selectedMailConfig.genericMailTemplate = newTempalte;
      this.showEditTemplateDialog = false;
      this.changeData();
    },
  },
};
</script>

<style scoped></style>
